module.exports = __webpack_public_path__ + "components/media-kit/static/icon-setup-e439dfda6b60e08316a609d860eee43a.svg";